import DeltaForge from '../components/DeltaForge';
import DeltaForgeLegacyPathRedirect from './deltaForgeLegacyRedirect';

const DELTA_FORGE_BASE_ROUTE = '/delta-forge';

const DELTA_FORGE_ROUTES = [
  {
    id: 'deltaForge',
    path: DELTA_FORGE_BASE_ROUTE,
    component: DeltaForge,
    exact: true
  },
  {
    id: 'deltaForgeLegacyDataQualityStatisticsPath',
    path: '/data_quality_statistics',
    component: DeltaForgeLegacyPathRedirect,
    exact: true
  },
  {
    id: 'deltaForgeLegacyUnderscorePath',
    path: '/delta_forge',
    component: DeltaForgeLegacyPathRedirect,
    exact: true
  }
];

export default DELTA_FORGE_ROUTES;
